export default __webpack_public_path__ + "static/plants-10d60047b668d2f9c34272d1dacd285b.jpg";